import { render, staticRenderFns } from "./Furnishing.vue?vue&type=template&id=a9cd66c6&"
import script from "./Furnishing.vue?vue&type=script&lang=js&"
export * from "./Furnishing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports